import { createStyles } from 'utils/createStyle';
import { colors } from 'styles/settings';

export const styles = createStyles({
    formHeader: ['text-4xl font-semibold text-center text-brand-dark', { marginBottom: 40 }],
    stepperButton: [
        'bg-brand text-white font-semibold text-lg leading-7 py-3.5 px-11 rounded-full inline-flex items-center justify-center disabled:bg-grey-2',
        {
            '&:disabled': {
                backgroundColor: colors.lineGrey,
                color: colors.grey3,
                cursor: 'default',
            },
        },
    ],
    stepperButtonClear:
        'bg-white text-brand font-semibold text-lg leading-7 py-3.5 px-8 rounded-full inline-flex items-center justify-center focus:outline-none',
    dateMarginContainer: ['flex flex-col space-y-5'],
    dateMarginRow: ['flex items-center space-y-5', { height: '100%' }],
    dateMarginEntry: ['absolute no-wrap ml-4 text-lg text-grey-darkest', { whiteSpace: 'nowrap' }],
    stepContentWrapper: ['', { marginBottom: 84, minHeight: 448 }],
});
